import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  MenuItem,
  Typography,
  Button,
  IconButton,
  Tooltip,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useSetAtom } from 'jotai';
import { searchValuesAtom } from '../../Atoms';

const SortMenuWidget = function SortMenuWidget({
  defaultSorting = null,
  sortingOptions = [],
  closeMenu,
}) {
  const intl = useIntl();
  const setSearchValues = useSetAtom(searchValuesAtom);
  const [sortName, setSortName] = useState(null);
  const [direction, setDirection] = useState('desc');

  const handleChangeDirection = () => {
    setDirection((x) => (x === 'asc' ? 'desc' : 'asc'));
  };

  const handleChangeSortName = (e, newValue) => {
    setSortName(newValue);
  };

  useEffect(() => {
    setDirection(defaultSorting?.direction);
    setSortName(defaultSorting?.value);
  }, [defaultSorting]);

  const onConfimSorting = () => {
    setSearchValues((prev) => ({
      ...prev,
      sortValue: { value: sortName, direction },
    }));
    closeMenu();
  };

  return (
    <div
      style={{
        padding: '0px 8px',
        minWidth: '16vw',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '4px',
          alignItems: 'center',
          marginBottom: '16px',
        }}
      >
        <Typography variant="body1" color="primary" sx={{ fontWeight: 'bold' }}>
          {intl.messages.ORDER}
        </Typography>
        <Tooltip title={intl.messages.CHANGE_DIRECTION} placement="bottom">
          <IconButton onClick={handleChangeDirection} color="primary">
            {direction === 'desc' ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
          </IconButton>
        </Tooltip>
      </div>
      {sortingOptions.map((option) => (
        <MenuItem
          key={option.label}
          disableGutters
          sx={{
            display: 'flex',
            pr: '2px',
            pl: '8px',
            justifyContent: 'space-between',
            borderRadius: '5px',
            color: sortName === option.value && 'primary.main',
            '&.Mui-selected': {
              background: 'white.main',
              fontWeight: 'bold',
            },
          }}
          selected={option.value === sortName}
          onClick={(e) => handleChangeSortName(e, option.value)}
        >
          {intl.messages[option.label] ?? option.label}
          {sortName === option.value && <CheckIcon />}
        </MenuItem>
      ))}
      <Button
        id="confirm-sorting-btn"
        fullWidth
        onClick={onConfimSorting}
        sx={{ mt: '16px' }}
      >
        {intl.messages.CONFIRM}
      </Button>
    </div>
  );
};

SortMenuWidget.propTypes = {
  defaultSorting: PropTypes.object,
  closeMenu: PropTypes.func.isRequired,
  sortingOptions: PropTypes.array,
};

export default SortMenuWidget;
